import React from 'react';
import PropTypes from 'prop-types';

const AccountNotFoundStep = ({
  isSubmitting,
  setFieldValue,
  footerNav,
}) => (
  <div className="personalization__not-found-step" data-testid="personalization-step:not-found">

    <div className="modal__section">
      <h1 className="modal__subsection modal__title modal__title--short">Personalize YourTour</h1>
      <div className="modal__subsection modal__description modal__description--short">
        There are no prospects matching your search.
        {' '}
        Click CREATE NEW PROSPECT to proceed.
      </div>
    </div>

    <div className="modal__section modal__btns modal__btns--inline">
      <button
        disabled={isSubmitting}
        type="submit"
        className="modal__btn modal__btn--secondary"
        onClick={() => {
          setFieldValue('action', 'create new');
        }}
        data-testid="personalization-create-new"
      >
        Create New Prospect
      </button>
    </div>

    {footerNav}

  </div>
);

AccountNotFoundStep.propTypes = {
  isSubmitting: PropTypes.bool.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  footerNav: PropTypes.node.isRequired,
};

export default AccountNotFoundStep;
